import { render, staticRenderFns } from "./VLayout.vue?vue&type=template&id=2c7a9888&scoped=true&"
import script from "./VLayout.vue?vue&type=script&lang=js&"
export * from "./VLayout.vue?vue&type=script&lang=js&"
import style0 from "./VLayout.vue?vue&type=style&index=0&id=2c7a9888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7a9888",
  null
  
)

export default component.exports